import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import React from 'react';
import ModalLogin from './Login/modal-login';
import { ModalForm, ModalState } from './modal';
import { GrayTile } from './tile/tile';
import { Tooltip } from './tooltip';
import LinkButton from "../v2023/UI/LinkButton/link-button"

export const Comparative = ({ comparative, headerTitle, thin = true, references = [], modals }) => {
	return (
		<>
			<ComparativeMobile comparative={comparative} thin={thin} references={references} />
			<ComparativeDesktop comparative={comparative} headerTitle={headerTitle} thin={thin} />
			{modals}
		</>
	)
}

const ComparativeMobile = ({ comparative, thin = true, references = [] }) => {
	return <div className='table-mobile show-md'>
		{comparative.map((item, index) => {
			return <div className='table-mobile-block' ref={references[index]}>
				<ComparativeMobileHeader comparative={item} />
				<ComparativeMobileBody
					characteristicsList={item.characteristicsList}
					thin={thin}
					seeButtons={item.seeButtons ?? null}
					limit={item.limit ?? 100}
					setLimit={item.setLimit ?? null}
				/>
			</div>
		})}
	</div>
}

const ComparativeMobileHeader = ({ comparative }) => {
	return <GrayTile thin>
		{typeof comparative.name === 'string' ? <h3>{comparative.name}</h3> : <GatsbyImage image={getImage(comparative.name.localFile)} alt={comparative.name.alternativeText} />}
		{comparative.headerButton && comparative.headerButton}
		{comparative.buttons.map(button => button)}
	</GrayTile>
}

const ComparativeMobileBody = ({ characteristicsList, thin, seeButtons, limit, setLimit }) => {
	const title = characteristicsList.title
	const characteristics = characteristicsList.characteristics.filter(characteristic => characteristic.bool || thin)

	// TODO
	return <div className='table-mobile-block__list'>
		{title && <h5>{title}</h5>}
		{characteristics.map((characteristic, index) =>
			index < limit && <div className={`table-mobile-block__list__item`}>
				<IconComponent bool={characteristic.bool} text={characteristic.text} onlyIcon thin={thin} />
				{/* {getIconText(characteristic.text, characteristic.bool)} */}
				<span>{characteristic.name}{characteristic.text ? `: ${characteristic.text}` : ''}</span>
				{characteristic.tooltip && <span className="tooltip-icon" data-tooltip={characteristic.tooltip}><i className="icon-info"></i></span>}
			</div>
		)}
		{seeButtons && <div className="container__see-more">
			<button className="button button--xl button--secondary" onClick={() => setLimit(limit < 100 ? 100 : 4)}>
				{limit === 100 ? seeButtons.seeLess : seeButtons.seeMore}
			</button>
		</div>}
	</div>
}

const ComparativeDesktop = ({ comparative, headerTitle, thin = true }) => {
	return <>
		<table className={`table ${thin ? 'table--thin' : ''} hidden-md`}>
			<ComparativeDesktopHeader comparative={comparative} headerTitle={headerTitle} />
			<ComparativeDesktopBody comparative={comparative} thin={thin} />
		</table>
	</>
}

const ComparativeDesktopHeader = ({ comparative, headerTitle }) => {
	return <thead>
		<tr>
			<th>
				{headerTitle
					?
					<div className="table__cell"><h6>{headerTitle}</h6></div>
					:
					<div className="table__cell" />
				}
			</th>
			{comparative.map(item => {
				return <th>
					<div className={`table__cell ${item.highlighted ? 'table__cell__highlight--top' : ''}`}>
						{typeof item.name === 'string' ? <h3>{item.name}</h3> : <GatsbyImage image={getImage(item.name.localFile)} alt={item.name.alternativeText} />}
						{item.headerButton && item.headerButton}
					</div>
				</th>
			})}
		</tr>
	</thead>
}

const ComparativeDesktopBody = ({ comparative, thin }) => {
	const characteristics = comparative[0].characteristicsList.characteristics
	const hasButtons = comparative.some(item => item && item.buttons && item.buttons.length > 0);

	return <tbody>
		{characteristics.map((characteristic, characteristicIndex) => {
			const isLastRow = characteristicIndex === characteristics.length - 1

			return (
				<tr key={characteristicIndex}>
					<td>
						<div className='table__cell'>
							{thin ? (<b>{characteristic.name}</b>) : (characteristic.name)}
							{characteristic.tooltip && <span className="tooltip-icon" data-tooltip={characteristic.tooltip}><i className="icon-info"></i></span>}
						</div>
					</td>
					<td>
						<div className={`table__cell ${comparative[0].highlighted ? 'table__cell__highlight--x' : ''}`}>
							<IconComponent bool={characteristic.bool} text={characteristic.text} thin={thin} />
						</div>
					</td>
					{comparative.map((row, index) => {
						if (index !== 0) {
							const characteristic = row.characteristicsList.characteristics[characteristicIndex]
							return <td>
								<div className={`table__cell ${comparative[index].highlighted && !isLastRow ? 'table__cell__highlight--x' : ''} 
								${comparative[index].highlighted && isLastRow && !hasButtons ? 'table__cell__highlight--bottom' : ''}`}>
									<IconComponent bool={characteristic.bool} text={characteristic.text} thin={thin} />
								</div>
							</td>
						}
					})}
				</tr>
			)
		})}
		{hasButtons && <ComparativeDesktopFooter comparative={comparative} />}
	</tbody>
}

const ComparativeDesktopFooter = ({ comparative }) => {
	// TODO
	return <tr>
		<td></td>
		{comparative.map(item => {
			return item !== null && <td>
				<div className={`table__cell ${item.highlighted ? 'table__cell__highlight--bottom' : ''}`}>
					{item.buttons.map(button => button)}
				</div>
			</td>
		})}
	</tr>

}

export const ComparativeCompetitors = ({
	title,
	comparative,
	tecalis,
	competitor,
	expertButton,
	expertForm,
	tryButton,
	tryForm,
	lang,
}) => {
	const tryModalState = ModalState();
	const tryButtonObj = { text: tryButton, modalState: tryModalState };
	const showTryForm = tryForm ? true : false;

	const expertModalState = ModalState();
	const expertButtonObj = { text: expertButton, modalState: expertModalState };

	return (
		<>
			<table className="table table--thin">
				{desktopComparativeHeader(tecalis, competitor)}
				{desktopComparativeBody(comparative, expertButtonObj, tryButtonObj, showTryForm)}
			</table>

			<ModalForm state={expertModalState} divFormId="expertForm" form={expertForm} />

			{tryForm && <ModalLogin state={tryModalState} lang={lang} selectedPlan="starter" plan={tryForm} />}
		</>
	);
};

const desktopComparativeHeader = (tecalis, competitor) => {
	return (
		<thead>
			<tr>
				<th>
					<div className="table__cell"></div>
				</th>
				<th>
					<div className="table__cell table__cell__highlight--top">
						<GatsbyImage image={getImage(tecalis.localFile)} alt={tecalis.alternativeText} />
					</div>
				</th>
				<th>
					<div className="table__cell">
						<h6>{competitor}</h6>
					</div>
				</th>
			</tr>
		</thead>
	);
};

const desktopComparativeBody = (comparative, expertButton, tryButton, showTryForm) => {
	return (
		<tbody>
			{comparative.map((row) => {
				return desktopComparativeRow(row);
			})}
			{desktopComparativeFooter(expertButton, tryButton, showTryForm)}
		</tbody>
	);
};

const desktopComparativeRow = (row) => {
	return (
		<tr>
			<td>
				<div className="table__cell">
					<b>{row.name}</b>
					<Tooltip tooltip={row.tooltip} />
				</div>
			</td>
			<td>
				<div className="table__cell table__cell__highlight--x">
					{/* {getIconText(row.text_tecalis, row.tecalis)} */}
				</div>
			</td>
			<td>
				{/* <div className="table__cell">{getIconText(row.text_competitor, row.competitor)}</div> */}
			</td>
		</tr>
	);
};

const desktopComparativeFooter = (expertButton, tryButton, showTryForm) => {
	return (
		<tr>
			<td></td>
			<td>
				<div className="table__cell table__cell__highlight--bottom">
					<button className="button button--lg" onClick={() => expertButton.modalState.openMenu()}>
						{expertButton.text}
					</button>
					{showTryForm && <span onClick={() => tryButton.modalState.openMenu()}>{tryButton.text}</span>}
				</div>
			</td>
			<td></td>
		</tr>
	);
};

const IconComponent = ({ text, bool, onlyIcon = false, thin = true }) => {
	if (!text && !bool) {
		return thin ? <i className="icon-close" /> : <i className="icon-dash" />;
	}
	if (onlyIcon) {
		return <i className="icon-check" />
	}
	return text ? text : <i className="icon-check" />
};
